import { Country, CountryLabels } from '@/types/Country';
import { Select, SelectProps } from 'antd';

interface Props extends Omit<SelectProps, 'options'> {
  isForeignDocument?: boolean;
}

const countryOptions = Object.values(Country).map((country) => ({
  value: country,
  label: CountryLabels[country],
}));

export default function CountrySelectField({
  isForeignDocument,
  ...props
}: Props) {
  const options = isForeignDocument
    ? countryOptions.filter(
        (countryOptions) => countryOptions.value !== Country.Brasil,
      )
    : countryOptions;

  return <Select {...props} options={options} />;
}
